import { apiFetch } from './core'

export type EmailStatus = 'pending_user' | 'pending_admin' | 'approved' | 'rejected'

export interface UserEmailOut {
  id: number
  email: string
  label: string | null
  is_primary: boolean
  status: EmailStatus
}

export interface PendingEmailOut {
  email_id: number
  user_id: number
  username: string
  email: string
  label: string | null
}

export interface UserEmailCreate {
  email: string
  label?: string | null
}

export interface UserEmailUpdate {
  email?: string
  label?: string | null
  is_primary?: boolean
}

export async function getMyEmails(): Promise<UserEmailOut[]> {
  return apiFetch<UserEmailOut[]>('/api/users/me/emails')
}

export async function addMyEmail(data: UserEmailCreate): Promise<UserEmailOut> {
  return apiFetch<UserEmailOut>('/api/users/me/emails', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function updateMyEmail(emailId: number, data: UserEmailUpdate): Promise<UserEmailOut> {
  return apiFetch<UserEmailOut>(`/api/users/me/emails/${emailId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}

export async function deleteMyEmail(emailId: number): Promise<void> {
  return apiFetch<void>(`/api/users/me/emails/${emailId}`, { method: 'DELETE' })
}

export async function getUserEmails(userId: number): Promise<UserEmailOut[]> {
  return apiFetch<UserEmailOut[]>(`/api/users/${userId}/emails`)
}

export async function addUserEmail(userId: number, data: UserEmailCreate): Promise<UserEmailOut> {
  return apiFetch<UserEmailOut>(`/api/users/${userId}/emails`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function updateUserEmail(userId: number, emailId: number, data: UserEmailUpdate): Promise<UserEmailOut> {
  return apiFetch<UserEmailOut>(`/api/users/${userId}/emails/${emailId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}

export async function deleteUserEmail(userId: number, emailId: number): Promise<void> {
  return apiFetch<void>(`/api/users/${userId}/emails/${emailId}`, { method: 'DELETE' })
}

export async function verifyEmailToken(token: string): Promise<{ status: string }> {
  return apiFetch<{ status: string }>(`/api/users/verify-email?token=${encodeURIComponent(token)}`)
}

export async function getPendingEmails(): Promise<PendingEmailOut[]> {
  return apiFetch<PendingEmailOut[]>('/api/admin/pending-emails')
}

export async function approveEmail(emailId: number): Promise<void> {
  return apiFetch<void>(`/api/admin/emails/${emailId}/approve`, { method: 'POST' })
}

export async function rejectEmail(emailId: number, reason?: string): Promise<void> {
  return apiFetch<void>(`/api/admin/emails/${emailId}/reject`, {
    method: 'POST',
    body: JSON.stringify({ reason: reason ?? null }),
  })
}

export interface LogoOut {
  has_logo: boolean
  logo_base64: string | null
}

export async function getMyLogo(): Promise<LogoOut> {
  return apiFetch<LogoOut>('/api/users/me/logo')
}

export async function saveMyLogo(logoBase64: string): Promise<LogoOut> {
  return apiFetch<LogoOut>('/api/users/me/logo', {
    method: 'PUT',
    body: JSON.stringify({ logo_base64: logoBase64 }),
  })
}

export async function deleteMyLogo(): Promise<void> {
  return apiFetch<void>('/api/users/me/logo', { method: 'DELETE' })
}
